import React from "react";

const defaultImprovementRows = [
  {
    label: "R&D",
    currentFY: "",
    previousFY: "",
    details: "",
  },
  {
    label: "Capex",
    currentFY: "",
    previousFY: "",
    details: "",
  },
];

const ImprovementImpactTable = ({ improvementData, setImprovementData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...improvementData];
    updated[index][field] = value;
    setImprovementData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}></th>
            <th style={tableHeaderStyle}>Current Financial Year</th>
            <th style={tableHeaderStyle}>Previous Financial Year</th>
            <th style={tableHeaderStyle}>
              Details of improvements in environmental and social impacts
            </th>
          </tr>
        </thead>
        <tbody>
          {improvementData.map((row, index) => (
            <tr key={index}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.label}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Current FY"
                  value={row.currentFY}
                  onChange={(e) =>
                    handleChange(index, "currentFY", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Previous FY"
                  value={row.previousFY}
                  onChange={(e) =>
                    handleChange(index, "previousFY", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <textarea
                  placeholder="Details"
                  value={row.details}
                  onChange={(e) =>
                    handleChange(index, "details", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  textAlign: "center",
  outline: "none",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default ImprovementImpactTable;
